<template>
  <div class="Responsive">
    <Mobile v-if="isMobile" />
    <Pc v-else />
  </div>
</template>

<script>
import Mobile from "@/views/Mobile.vue";
import Pc from "@/views/Pc.vue";

export default {
  components: {
    Mobile,
    Pc,
  },
  created() {
    this.resizeCallback = () => {
      this.isMobile = window.device === "mobile";
      if (window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    };
    window.addEventListener("resize", this.resizeCallback);
    if (window.innerWidth < 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted() {
    if (window.innerWidth < 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeCallback);
  },
  data() {
    return { isMobile: window.device === "mobile" };
  },
};
</script>
